import React, { RefObject } from 'react'
import PropTypes from 'prop-types'
import { View, StyleSheet } from 'react-native'
import { SwatchGroup } from './swatch-group'
import { SwatchImageGroup } from './swatch-image-group'
import { REACT_NATIVE_API } from '../constants'
import { Group } from '../types/group'

type ProductOptionsProps = {
  sku?: string,
  /** The primary color of the component. */
  accentColor: string,
  /** The options represented. */
  optionGroups?: Array<Group>,
  /** The selected height index (e.g Desk Height, Medium Bench, High Bench") */
  selectedHeight: number,
  /** Controls whether or not to show the height options. */
  showHeightOptions: boolean,
  /** Controls whether or not to show the High bench for shells chairs */
  showHeightOptionsShellChairs,
  /** The views React ref for setting the auto scroll. */
  viewRef?: RefObject<View> | null,
  /** Called whenever the swatch button is clicked. */
  onSwatchChange: Function,
  /** Called whenever the image swatch button is clicked. */
  onImageSwatchChange: Function,
  /** Called whenever the height option is changed. */
  onHeightChange: Function,
  partner: string,
  /** Drilled to determine whether or not we are on mobile*/
  onMobile: boolean
}

/**
 * Displays all of the product options available.
 * @component
 */
export class ProductOptions extends React.Component<ProductOptionsProps> {
  static propTypes = {
    sku: PropTypes.string,
    accentColor: PropTypes.string,
    optionGroups: PropTypes.array,
    selectedHeight: PropTypes.number.isRequired,
    showHeightOptions: PropTypes.bool.isRequired,
    viewRef: PropTypes.object,
    onSwatchChange: PropTypes.func.isRequired,
    onImageSwatchChange: PropTypes.func.isRequired,
    onHeightChange: PropTypes.func.isRequired,
    partner: PropTypes.string.isRequired,
  }

  render() {
    return (
      <View ref={this.props.viewRef} style={styles.container}>
        {this.props.optionGroups?.filter((opt: Group) => opt.type !== 'image').map((optionGroup: Group, key: number) => {
          if (optionGroup.type === 'basic') {
            return (<SwatchGroup
              accentColor={this.props.accentColor}
              type={optionGroup.type}
              name={optionGroup.name}
              swatches={optionGroup}
              selected={optionGroup.selected}
              key={key + 2}
              onSwatchChange={this.props.onSwatchChange}
            />)
          } else {
            return (<SwatchImageGroup
              sku={this.props.sku}
              accentColor={this.props.accentColor}
              name={optionGroup.name}
              swatches={optionGroup}
              selected={optionGroup.selected}
              key={key + 2}
              onImageSwatchChange={this.props.onImageSwatchChange}
              partner={this.props.partner}
              onMobile={this.props.onMobile}

            />)
          }
        })}
        {
          this.props.showHeightOptions &&
          <SwatchGroup
            accentColor={this.props.accentColor}
            type="basic"
            name="Height"
            swatches={{
              selected: this.props.selectedHeight,
              group: this.props.showHeightOptionsShellChairs == true
              ? [{key: 0, label: 'Desk Height', option: ''}, {key: 1, label: 'Medium Bench', option: ''}, {key: 2, label: 'High Bench', option: ''}]
              : [{key: 0, label: 'Desk Height', option: ''}, {key: 1, label: 'Medium Bench', option: ''}]
            , option: ''}}
            selected={this.props.selectedHeight}
            key={1}
            onSwatchChange={(key: number, groupName: string) => this.props.onHeightChange(key)}
          />
        }
        {
          this.props.optionGroups?.filter(opt => opt.type === 'image').map((optionGroup, key) => {
            return (
              <SwatchImageGroup
                sku={this.props.sku}
                accentColor={this.props.accentColor}
                name={optionGroup.name}
                swatches={optionGroup}
                selected={optionGroup.selected}
                key={0}
                onImageSwatchChange={this.props.onImageSwatchChange}
                partner={this.props.partner}
                onMobile={this.props.onMobile}
              />
            )
          })
        }
      </View>
    )
  }
}

const styles = StyleSheet.create({
  container: {
    width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'column-reverse'
  },
})